import QueryString from 'query-string'

export const IMPACT_RADIUS_SOURCE = 'impactradius'
export const REFERRALS_SOURCE = 'Referrals'

// This is a fallback value but should not ever be used; will remove once all affiliate links are validated
const IMPACT_RADIUS_SOURCE_ALT = 'impact_radius'

/**
 * Removes duplicate query parmas from query string
 * @param input Query string of current page
 * @param shouldTrackAttributes Flag to determine if we should send metrics
 * @returns Object containing proper values for each query param or empty object
 */
const removeDuplicateQueryParams = (input: string | undefined, shouldTrackAttributes = false) => {
  if (input) {
    const parsed = QueryString.parse(input)
    const droppedAttributes = {}

    let impactRadiusIndex = parsed?.s1?.indexOf(IMPACT_RADIUS_SOURCE)
    if (impactRadiusIndex === -1) impactRadiusIndex = parsed?.s1?.indexOf(IMPACT_RADIUS_SOURCE_ALT)

    for (const key in parsed) {
      if (Array.isArray(parsed[key])) {
        // If s1=impact_radius is present that value should be used for s1 key
        // for other params use the value that has the same index as impact_radius in s1
        if (impactRadiusIndex !== -1 && impactRadiusIndex !== undefined) {
          droppedAttributes[key] = parsed[key]
            .filter((_, index) => index !== impactRadiusIndex)
            .toString()
          parsed[key] = key === 's1' ? IMPACT_RADIUS_SOURCE : parsed[key][impactRadiusIndex]
        } else {
          // use the last instance of the param's value
          const tempDroppedAttributes = [...parsed[key]]
          tempDroppedAttributes.pop()
          droppedAttributes[key] = tempDroppedAttributes.toString()
          parsed[key] = parsed[key][parsed[key].length - 1]

          // handle param not having a value i.e: /signup?s1=val1&s1=
          // if last instance of param doesn't have value, use the value that came before
          if (!parsed[key]) {
            parsed[key] = tempDroppedAttributes.reverse().find(attr => {
              return attr && attr
            })
          }
        }
      }
    }

    // only track when flag is passed to ensure that we don't track duplicates every time query params are parsed
    if (window.analytics && droppedAttributes && shouldTrackAttributes) {
      window.analytics.track('Dropped Attributes', {
        eventData: {
          event: 'dropped_attributes',
          droppedAttributes,
        },
      })
    }

    return parsed
  }

  return {}
}

export default removeDuplicateQueryParams
